module.exports = __webpack_public_path__ + "img/ball.6f4f919d.svg";